<template>
  <div class="form_field flex_field_column border-bottom">
    <div class="label_container">
      <div class="add-info">
        <label>Informazioni aggiuntive:</label>
      </div>
      <div class="text_container">
        <p class="add-equipments">
          In questo campo si deve inserire il chilometraggio e gli equipaggiamenti opzionali
          dell’auto per farli rientrare nella quotazione (attenzione non tutti gli equipaggiamenti
          opzionali sono considerati dal mercato). Altre indicazioni e note saranno vagliate dal
          Team di Quotamoto, ma considerazioni che esulano da quanto considerato nelle nostre stime,
          come lo stato d’uso del veicolo, saranno ignorate
        </p>
      </div>
    </div>

    <div class="container_textarea">
      <textarea
        name="add_description"
        id="add-desc"
        cols="10"
        rows="5"
        placeholder="Descrivi la tua moto e la relativa offerta"
        :required="required"
        v-model="text"
        @input="emitValidation"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormFieldAddInfo',
  props: {
    required: { type: Boolean, default: true },
    minChars: { type: Number, default: 10 },
  },
  data() {
    return {
      text: '',
    };
  },
  computed: {
    isValid() {
      if (!this.required) return true;
      return this.text && this.text.trim().length >= this.minChars;
    },
  },
  watch: {
    required: function() {
      this.emitValidation();
    },
    minChars: function() {
      this.emitValidation();
    },
  },
  methods: {
    emitValidation() {
      const v = !!this.isValid;
      this.$emit('validation', v);
    },
  },
  mounted() {
    this.emitValidation();
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldAddInfo.vue